'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const components_forms_FormLabel_FormLabelRequiredText = require('./FormLabelRequiredText.cjs.js');

const Styles = styleEncapsulation.labelStyles("FormLabel", {
  root: react.css`
    display: grid;
    justify-content: start;
    grid-gap: var(--zds-space-2);
    grid-auto-flow: column;
    grid-auto-columns: auto;
    cursor: pointer;
    color: var(--zds-text-default);

    &[data-align-items='center'] {
      align-items: center;
    }

    &[data-align-items='start'] {
      align-items: start;
    }

    &[data-justify-content='start'] {
      justify-content: start;
    }

    &[data-justify-content='stretch'] {
      justify-content: stretch;
    }

    &[data-state~='selected'] {
      color: var(--zds-text-default);
    }

    &[data-state~='errored'] {
      color: var(--zds-status-error-stronger);
    }

    &[data-state~='disabled'] {
      cursor: not-allowed;
      color: var(--zds-text-weakest);
    }

    &[data-size='compact'] {
      ${theme_Typography.Typography.MinimalPrint3}
    }

    &[data-size='small'] {
      ${theme_Typography.Typography.SmallPrint3}
    }

    &[data-size='medium'] {
      ${theme_Typography.Typography.Body2}
    }

    &[data-size='medium'][data-state='selected'] {
      ${theme_Typography.Typography.Body3}
    }
  `,
  asterisk: react.css`
    ${theme_Typography.Typography.Body2Multiline}
    color: var(--zds-ui-brand);
    text-decoration: none;
  `
});
const FormLabel = ({ children, alignItems = "center", htmlFor = void 0, isDisabled = void 0, isErrored = void 0, isRequired = void 0, isSelected = void 0, justifyContent = "start", requiredText = void 0, size = "medium" }) => {
  return react.jsx(
    "label",
    { css: Styles.root, "data-align-items": alignItems, "data-justify-content": justifyContent, "data-size": size, "data-state": [
      isSelected && "selected",
      isErrored && "errored",
      isDisabled && "disabled"
    ].filter(Boolean).join(" ") || void 0, "data-zds": true, htmlFor },
    children,
    isRequired && react.jsx("abbr", { css: Styles.asterisk, title: "required" }, "*"),
    isRequired ? requiredText ? react.jsx(components_forms_FormLabel_FormLabelRequiredText.FormLabelRequiredText, { isDisabled }, requiredText) : react.jsx(components_forms_FormLabel_FormLabelRequiredText.FormLabelRequiredText, { isDisabled }) : null
  );
};

exports.FormLabel = FormLabel;
//# sourceMappingURL=FormLabel.cjs.js.map
